<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDLE')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-module-submodule-select
            ref="module"
            :selectedMd="frame0.selectedCode.COD_MDLE"
            :selectedSmd="frame0.selectedCode.COD_SMDLE"
            @submodule-selected="moduleLoaded"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RUL_NM')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="frame0.ruleName"
            maxlength="50"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RUL_TYPE')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-code-select
            ref="ruleCodeType"
            :selected="frame0.selectedCode.COD_TYPE"
            codeId="COD_RULE_TYPE"
            :initialSelectedIndex="0"
            @loaded="ruleCodeTypeLoaded"
          />
        </div>
     
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_USE_YN')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-radio
            v-model="frame0.ruleUseYn"
            value="Y"
          >
            Yes
          </sui-radio>
          <sui-radio
            v-model="frame0.ruleUseYn"
            value="N"
          >
            No
          </sui-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_DTSVC')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_scrInput_wrap">
            <sui-text-field
              v-model="frame0.dataServiceId"
              maxlength="100"
              style="width:100%;"
              :readonly="true"
              fixedIcon
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onClickDataService"
            />
          </div>
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_PAGE')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_scrInput_wrap">
            <sui-text-field
              v-model="frame0.pageId"
              maxlength="100"
              style="width:100%;"
              :readonly="true"
              fixedIcon
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onClickPage"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RUL_CNTN')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-11">
          <textarea
            v-model="frame0.ruleExplanationContent"
            name="name"
            maxlength="1000"
          />
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:create="pageId"
        type="button"
        class="comm_btn_border"
        @click="onClickNew"
      >
        {{ $t('MSG_BTN_NEW') }}
      </sui-button>
      <sui-button
        v-permission:delete="pageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDelete"
      >
        {{ $t('MSG_BTN_DEL') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_border_Prime"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
      <sui-button
        v-permission:create="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickConfirm"
      >
        {{ $t('MSG_BTN_REFLECTION') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    ruleUid: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectBoxLoadFlag: false,
      mountedFlag: true,
      frame0: {
        selectedCode: {
          COD_TYPE: {
            key: '',
            label: '',
          },
          COD_MDLE: {
            key: '',
            label: '',
          },
          COD_SMDLE: {
            key: '',
            label: '',
          },
        },
        ruleUid: '',
        ruleName: '',
        ruleUseYn: '',
        ruleExplanationContent: '',
        dataServiceId: '',
        pageId: '',
        ruleConditionContent: '',
        nodeToDoUid: '',
        dataServiceName: '',
        dataServiceUniformresourcelocator: '',
      },
    };
  },
  computed: {},
  watch: {
    ruleUid() {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setRuleData();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setRuleData();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 저장되지 않은 데이터 확인
     */
    makeSnapshot() {
      const snapshotData = utils.assign({},
        this.frame0,
        {
          ruleTypeCode: this.frame0.selectedCode.COD_TYPE.key,
          moduleCode: this.frame0.selectedCode.COD_MDLE.key,
          subModuleCode: this.frame0.selectedCode.COD_SMDLE.key,
        });

      return snapshotData;
    },
    ruleCodeTypeLoaded() {
      if (this.selectBoxLoadFlag && this.mountedFlag) {
        this.saveSnapshot(this.makeSnapshot());
        this.mountedFlag = false;
      }
      this.selectBoxLoadFlag = true;
    },
    moduleLoaded() {
      if (this.selectBoxLoadFlag && this.mountedFlag) {
        this.saveSnapshot(this.makeSnapshot());
        this.mountedFlag = false;
      }
      this.selectBoxLoadFlag = true;
    },
    /**
     * 선택 된 row 정보를 tab01 정보에 셋팅.
     */
    setRuleData() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.frame0[key].COD_TYPE.key = this.selectedRowData.ruleTypeCode;
          this.frame0[key].COD_MDLE.key = this.selectedRowData.moduleCode;
          this.frame0[key].COD_SMDLE.key = this.selectedRowData.subModuleCode;
        } else if (utils.isEqual(key, 'pageId') || utils.isEqual(key, 'dataServiceId')) {
          this.frame0[key] = utils.trim(this.selectedRowData[key]);
        } else {
          this.frame0[key] = this.selectedRowData[key] || '';
        }
      });
      // 초기 데이터 생성
      this.saveSnapshot(this.makeSnapshot());
    },
    /**
     * 반영
     */
    onClickConfirm() {
      http.request(this.pageId, 'DTS_CMR_00047', {
        path: { 'rule-uid': this.ruleUid },
      }).then(res => {
        utils.openTextAreaEditor(this.ruleConfirm, {
          title: '',
          pageInitialData: {
            value: res.data.ruleText,
            readonly: true,
            positiveButtonText: this.$t('MSG_BTN_CFRM')
          },
        });
        // utils.messageBox('confirm', '', res.data.ruleText.split('\n'), () => {
        //   this.ruleConfirm();
        // });
      });
    },
    ruleConfirm(data) {
      // 팝업 return 확인 취소 여부를 return 값이 있는지 없는지로 구분
      if(utils.isEmpty(data)) return;

      http.request(this.pageId, 'DTS_CMR_00048', {
        path: { 'rule-uid': this.ruleUid },
      }).then(res => {
        if (utils.isEqual(res.data.resultCode, '0')) {
          utils.messageBox('warning', '', res.data.msg.split('\n'));
        } else {
          utils.messageBox('information', this.$t('MSG_ALT_SUCCESS_RFL'));
        }
      });
    },
    /**
     * 저장
     */
    onClickSave() {
      const serviceName = utils.isEmpty(this.ruleUid) ? 'DTS_CMR_00006' : 'DTS_CMR_00008';
      const dataParams = {
        ruleUid: this.ruleUid,
        ruleName: this.frame0.ruleName,
        ruleTypeCode: this.frame0.selectedCode.COD_TYPE.key,
        moduleCode: this.frame0.selectedCode.COD_MDLE.key,
        subModuleCode: this.frame0.selectedCode.COD_SMDLE.key,
        ruleExplanationContent: this.frame0.ruleExplanationContent,
        dataServiceId: this.frame0.dataServiceId,
        pageId: this.frame0.pageId,
        ruleConditionContent: this.frame0.ruleConditionContent,
        ruleUseYn: this.frame0.ruleUseYn,
        nodeToDoUid: this.frame0.nodeToDoUid,
        dataServiceName: this.frame0.dataServiceName,
        dataServiceUniformresourcelocator: this.frame0.dataServiceUniformresourcelocator,
      };

      if (!this.validationCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, serviceName, {
          data: dataParams,
        }).then(res => {
          // 초기 데이터 생성
          this.saveSnapshot(this.makeSnapshot());

          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));

          this.$emit('onClickSearch');

          if (utils.isEmpty(this.ruleUid)) {
            dataParams.ruleUid = res.data.msg;
            this.$emit('setRuleInfo', dataParams);
          }
        });
      });

      return true;
    },
    /**
     * 삭제
     */
    onClickDelete() {
      const dataParams = {
        ruleUid: this.ruleUid,
      };

      if (utils.isEmpty(utils.trim(this.ruleUid))) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        return false;
      }

      utils.messageBox('confirm', this.$t('MSG_ALT_DO_DELETE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00007', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'));
          this.$emit('onClickSearch');
          this.onClickNew();
        });
      });

      return true;
    },
    /**
     * 리셋
     */
    onClickNew() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.$refs.ruleCodeType.reset();
          // this.$refs.module.reset();
          this.$refs.module.selectMd('CM');
        } else {
          this.frame0[key] = '';
        }
      });

      this.oldTextValue = '';

      this.$emit('onClickNew');
      // 초기 데이터 생성
      this.saveSnapshot(this.makeSnapshot());
    },
    /**
     * 페이지 선택 공통팝업
     */
    onClickPage() {
      utils.openLayerPopup('PGE_CMU_00004', this.onPagePopupCallback, {
        pageInitialData: {
          selectionmode: 'singlerow', /* 'checkbox' 등 */
        },
        size: 'lg',
      });
    },
    onPagePopupCallback(nodeData) {
      if (nodeData) {
        this.frame0.pageId = nodeData[0].pageId;
      }
    },
    /**
     * 데이터서비스 선택 공통팝업
     */
    onClickDataService() {
      utils.openLayerPopup('PGE_CMU_00005', this.onDataServicePopupCallback, {
        pageInitialData: { selectionmode: 'singlerow' },
        size: 'xlg',
      });
    },
    onDataServicePopupCallback(nodeData) {
      if (nodeData) {
        this.frame0.dataServiceId = nodeData[0].dataServiceIdentification;
        this.frame0.dataServiceName = nodeData[0].dataServiceName;
        this.frame0.dataServiceUniformresourcelocator = nodeData[0].dataServiceUniformresourcelocator;
      }
    },
    /**
     * 입력 체크
     */
    validationCheck() {
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_MDLE.key))) {
        // 모듈을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_SMDLE.key))) {
        // 서브모듈을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.ruleName))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RUL_NM')),
          null,
          () => {
            this.$refs.ruleName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_TYPE.key))) {
        // 룰유형을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_RUL_TYPE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.ruleUseYn))) {
        // 사용여부를 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_USE_YN')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.dataServiceId))) {
        // 데이터서비스를 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DTSVC')));
        return false;
      }

      return true;
    },
  },
  datasets: [],
};
</script>
<style scoped>
</style>
